import './plot-properties.scss';
import { h } from 'preact';

import PlotPropertyField from './components/PlotPropertyField/PlotPropertyField';
import PlotPropertyFieldAlternative from './components/PlotPropertyFieldAlternative/PlotPropertyFieldAlternative';

const { __ } = wp.i18n;

export default function PlotProperties({ properties }) {
	return (
		<div class="plot-properties-container plot-section-container">
			<h3 class="plot-properties-header plot-section-header">{__('Properties', 'real-estate-project')}</h3>
			{properties.length > 0 ?
				<table>
					{properties.map(property => (
						property.name === 'w_prijsbereik' || property.name === 'w_prijs' ? <PlotPropertyFieldAlternative {...property} /> : <PlotPropertyField {...property} />
					))}
				</table> : ''}
		</div>
	);
}
